import { AnalyticOverviewDTO } from '../dtos/Overview.dto';
import { DataPoint } from '../infra/types/AnalyticsOverviewTypes';

export class AnalyticsOverviewUtil {
  public static mapToViewModel(dto: AnalyticOverviewDTO): DataPoint[] {
    return [
      {
        label: 'Communities',
        value: dto.communities,
      },
      {
        label: 'Users',
        value: dto.members,
      },
      {
        label: 'Views',
        value: dto.views,
      },
      {
        label: 'Conversions',
        value: dto.conversions,
      },
      {
        label: 'Published Content',
        value: dto.posts,
      },
      {
        label: 'Sent Notificaiton',
        value: dto.notifications,
      },
    ];
  }
}
